import { render, staticRenderFns } from "./periodic.vue?vue&type=template&id=4ca10458&scoped=true"
import script from "./periodic.vue?vue&type=script&lang=js"
export * from "./periodic.vue?vue&type=script&lang=js"
import style0 from "./periodic.vue?vue&type=style&index=0&id=4ca10458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca10458",
  null
  
)

export default component.exports